import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import {
  FaMicrophoneAlt,
  FaTshirt,
  FaShieldAlt,
  FaExclamationCircle,
} from "react-icons/fa";
import { PiDetective } from "react-icons/pi";
import { BsRobot } from "react-icons/bs";
import { MdDevices } from "react-icons/md";
import { FaLock } from "react-icons/fa6";
import featurebanner from "../Images/featurebanner.jpg";
import officehall from "../Images/officehall.jpg";
import arr_down from "../Images/arr_down.svg";
import nearbyfacilty from "../Images/nearbyfacilty.avif";
import excercisesbanner from "../Images/excercisebanner.png";
import bookings from "../Images/bookings.png";
import registeredfacilitiesbannerhome from "../Images/cropped-clipart.png";
import underline from "../Images/underline.png";
import desk from "../Images/desk.jpg";
import hands from "../Images/hands.jpg";
import { Link } from "react-router-dom";

const Features = () => {
  return (
    <div>
      <Header />
      <section
        className="relative py-40 text-white"
        style={{
          backgroundImage: `url(${featurebanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container mx-auto px-4 relative max-w-xl">
          <div className=" backdrop-blur-sm bg-black-50/30 rounded-md p-8 shadow-lg">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-sans">Transform Recruitment</h1>
              <h2 className="mt-4 text-lg italic font-normal">
                "Explore cutting-edge tools designed to simplify, secure, and
                elevate your hiring experience."
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="bg-white" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-2xl sm:py-16 lg:px-6">
          <div className="flex flex-col lg:flex-row items-center space-y-8 h-auto">
            <div className="lg:w-[40%] h-full order-last lg:order-first lg:pt-0 pt-10">
              <div className="w-full" data-aos="fade-up">
                <img
                  src={officehall}
                  alt="onlinemeeting"
                  className="w-full h-full rounded-lg"
                />
              </div>
            </div>
            <div className="lg:w-[60%] lg:pl-8">
              <h2 className="text-2xl md:text-3xl lg:text-3xl font-semibold text-slate-500">
                What's in it for Recruiter?
              </h2>
              <p className="text-gray-600 mt-3 font-semibold">
                Our platform is revolutionizing the recruitment process by
                offering an array of advanced tools designed to simplify and
                enhance every stage. With real-time monitoring, recruiters can
                ensure the integrity of interviews by detecting unauthorized
                activities or external device usage. The AI-driven insights
                provide a detailed analysis of candidate responses, offering
                actionable data to make well-informed decisions. Additionally,
                our platform features a streamlined workflow that consolidates
                scheduling, tracking, and reporting into an intuitive dashboard,
                saving recruiters valuable time and effort. From enhancing
                efficiency to ensuring transparency and accuracy, our solution
                empowers recruiters to focus on what matters most—hiring the
                right talent.
                <br />
                Our platform not only ensures secure and authentic interviews
                but also provides recruiters with tools to track progress,
                generate reports, and analyze data effortlessly. With everything
                centralized in one place, decision-making becomes faster and
                more reliable. Simplify your recruitment process while
                maintaining the highest standards of integrity and efficiency.
              </p>
              <div className="mt-6" data-aos="slide-up">
                <h4 className="mb-2 text-xl font-bold text-gray-900">
                  Tailored Solutions
                </h4>

                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-semibold">Streamlined Dashboard</p>
                  </div>
                  <div className="relative w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-slate-400 h-2.5 rounded-full"
                      style={{ width: "97%", position: "relative" }}
                    >
                      <div className="w-5 h-5 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 right-[-10px] border border-[#0A8AE6]"></div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-semibold">Real-Time Monitoring</p>
                  </div>
                  <div className="relative w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-slate-400 h-2.5 rounded-full"
                      style={{ width: "95%", position: "relative" }}
                    >
                      <div className="w-5 h-5 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 right-[-10px] border border-[#0A8AE6]"></div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-semibold">Comprehensive Reports</p>
                  </div>
                  <div className="relative w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-slate-400 h-2.5 rounded-full"
                      style={{ width: "100%", position: "relative" }}
                    >
                      <div className="w-5 h-5 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 right-[-10px] border border-[#0A8AE6]"></div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-semibold">AI-Powered Insights</p>
                  </div>
                  <div className="relative w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-slate-400 h-2.5 rounded-full"
                      style={{ width: "98%", position: "relative" }}
                    >
                      <div className="w-5 h-5 bg-white rounded-full absolute top-1/2 transform -translate-y-1/2 right-[-10px] border border-[#0A8AE6]"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className=" rounded-5xl rounded-tl-none m-10 p-10 flex flex-col items-center text-center max-w-[80vw] mx-auto"
        data-aos="fade-up"
      >
        <div className="flex flex-col md:flex-row my-10 space-y-4 md:space-y-0">
          <div className="w-full md:w-1/2 pr-2">
            <p className="font-semibold  text-2xl md:text-xl lg:text-2xl text-left">
              Never Miss Out on amazing candidate with our tools! Detection at
              interviews at its finest.
            </p>
          </div>
          <div className="w-full md:w-1/4 border-t md:border-t-0 md:border-l border-black pt-4 md:pt-0">
            <h1 className="font-semibold text-4xl md:text-3xl lg:text-5xl">
              40+
            </h1>
            <h4 className="text-sm">Helpfull Tools</h4>
          </div>
          <div className="w-full md:w-1/4 border-t md:border-t-0 md:border-l border-black pt-4 md:pt-0">
            <h1 className="font-semibold text-4xl md:text-3xl lg:text-5xl">
              50,000
            </h1>
            <h4 className="text-sm">Total Recrutors</h4>
          </div>
        </div>

        <div className="overflow-hidden w-full">
          <div
            className="flex space-x-28 animate-marquee justify-center"
            data-aos="fade-up"
          >
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img src={bookings} alt="title" className="w-16 h-16 mr-4" />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company one</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={excercisesbanner}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company two</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={registeredfacilitiesbannerhome}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company three</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
            <div className="flex items-center rounded-lg p-4 my-2 min-w-max">
              <img
                src={nearbyfacilty}
                alt="title"
                className="w-16 h-16 mr-4 rounded-2xl bg-white"
              />
              <div className="flex flex-col items-start">
                <h1 className="font-medium text-lg">Company four</h1>
                <p className="text-sm text-gray-600">Sample text</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="home bg-white mt-6 py-16" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-8 lg:px-6 flex flex-col lg:flex-row items-center space-y-8">
          <div className="w-full md:w-6/12 h-auto">
            <img
              src={hands}
              alt="image1"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <div className="home-content lg:w-3/4 lg:p-0 lg:pl-20 ">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Innovative Features That Redefine Hiring
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                Our platform is equipped with advanced tools and intelligent
                capabilities designed to streamline the recruitment process.
                From ensuring interview integrity to providing actionable
                insights, our features empower both recruiters and candidates
                for a seamless and efficient experience
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
        </div>
      </section>
      <section className="home bg-gray-100 mt-6" data-aos="fade-up">
        <div className="py-8 px-4 mx-auto max-w-screen-xl container sm:py-8 lg:px-6 flex flex-col lg:flex-row items-center space-y-8">
          <div className="home-content lg:w-3/4 lg:p-20 lg:pl-0">
            <div className="title">
              <h2 className="text-xl lg:text-3xl font-semibold text-[#64748B]">
                Recruitment with Advanced Capabilities
              </h2>
            </div>
            <div className="description mt-4 lg:mt-6">
              <p className="text-gray-600 font-semibold">
                Discover a suite of innovative features tailored to make your
                hiring process smarter and more secure. With AI-driven tools and
                intuitive functionalities, our platform ensures integrity,
                efficiency, and detailed insights at every step.
              </p>
            </div>
            <Link to="/signin">
              <button className="mt-8 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300">
                Explore Now
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </Link>
          </div>
          <div className="w-full md:w-6/12 h-auto">
            <img src={desk} alt="image1" className="w-full h-auto rounded-lg" />
          </div>
        </div>
      </section>
      <section id="services" data-aos="fade-up">
        <div className="bg-transparent mt-12 flex flex-col items-center text-center w-full mx-auto">
          <h1 className="text-2xl md:text-4xl tracking-tight m-0">
            Who We Are and What We Stand For
          </h1>
          <p className="text-lg text-gray-700 m-0 px-4 mt-2">
            Our commitment lies in empowering individuals and businesses through
            cutting-edge technology and a passion for excellence.
          </p>
        </div>
        <div className="py-8 mx-auto max-w-screen-2xl sm:py-16 lg:px-0">
          <div className="flex flex-col items-center space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Mission</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  To deliver world-class solutions that empower businesses and
                  individuals to achieve their goals effortlessly.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Vision</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  To be a global leader in technological innovation and set new
                  standards of excellence.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Values</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  We believe in transparency, integrity, and putting our clients
                  at the center of everything we do.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Why Choose Us</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  Our team of experts ensures seamless delivery, personalized
                  support, and solutions tailored to your needs
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Expertise</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  From AI-powered tools to dynamic web solutions, we have a
                  diverse range of expertise to transform your ideas into
                  reality.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Journey</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  With years of experience and countless success stories, we are
                  constantly evolving to meet your challenges.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 bg-gray-100" data-aos="fade-up">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-semibold mb-8 text-center">
            Our Advanced Capabilities
          </h2>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <PiDetective size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Real-Time Monitoring
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <BsRobot size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">AI-Powered Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaMicrophoneAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Voice Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <MdDevices size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Multi-Device Detection
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaShieldAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Secure Administration
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaExclamationCircle size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Suspicious Activity Alerts
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaLock size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Data Encryption</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaTshirt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Role Based Privileges
              </span>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-transparent mt-12 flex flex-col items-center text-center w-full mx-auto">
        <h1 className="text-2xl md:text-4xl tracking-tight m-0 font-semibold">
          Frequently Asked Questions
        </h1>
      </div>
      <section
        className="px-1 md:px-2 pb-8 pt-10 flex justify-between flex-col md:flex-row max-w-screen-2xl mx-auto"
        data-aos="fade-up"
      >
        <div className="w-full mt-1 md:mt-4">
          <details className="border border-[#F2F4F5] rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7 ">
              What services do you provide?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              We specialize in web and app development, AI-driven solutions, and
              UI/UX design tailored to your unique needs.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              What industries do you serve?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Our solutions are versatile, serving industries like e-commerce,
              healthcare, education, and more.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How do we ensure project success?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Through detailed planning, transparent communication, and
              milestone-based progress tracking, we ensure on-time and
              top-quality delivery.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How can I get started with your services?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Simply reach out through our contact page, and our team will guide
              you through the onboarding process.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              When do I reset a password ?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Yes, in order to use My Page, you must allow the use of cookies in
              your browser.
              <br />
              <br />
              See also: What is a cookie and what does it do?
            </p>
          </details>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Features;
